import React from "react";
import { Box, Container, Typography, useMediaQuery } from "@mui/material";

// Import images for assets
import CryptoImage from "/Images/otcicon1.svg";
import TokenizedImage from "/Images/otcicon2.svg";
import CurrencyImage from "/Images/otcicon3.svg";
import OtcIcon1 from "/Images/otcicon4.svg";
import OtcIcon2 from "/Images/otcicon5.svg";
import OtcIcon3 from "/Images/otcicon6.svg";

const Solution = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  return (
    <section
      style={{
        backgroundColor: "#E7E4E2",
        paddingBottom: "3rem",
        position: "relative",
        fontFamily: "Poppins",
      }}
    >
      <Container
        style={{
          width: "90%",
          maxWidth: "1260px",
          backgroundColor: "#E7E4E2",
          paddingTop: "rem",
          padding: isMobile ? "1rem" : "1.5rem",
          position: "relative",
          zIndex: "1",
          fontFamily: "Poppins",
        }}
      >
        {/* Title */}
         <h3
          align="center"
          style={{
            fontWeight: "bold",
            background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            marginTop: "4rem",
            marginBottom: "4rem",
            fontSize: isMobile ? "30px" : "40px",
            width: isMobile? "auto":"737px",
            marginLeft:"auto",
            marginRight:"auto",

           }}
        >
          Discover Tennet's OTC Service Secure and Seamless Transactions
        </h3>

        {/* Card Layout */}
        <Box
          display="flex"
          flexDirection={isMobile ? "column" : "row"}
          justifyContent="space-between"
          gap="1rem"
          flexWrap="wrap"
        >
          {/* Card 1 */}
          <Box
            style={{
              flex: isMobile ? "1 1 100%" : "1 1 30%",
              padding: "1rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              backgroundColor: "#E7E4E2",
              textAlign: "center",
              marginBottom: isMobile ? "1rem" : "0",
            }}
          >
            <img
              src={CryptoImage}
              alt="Support Stablecoin"
              style={{ width: "4rem", marginBottom: "1rem" }}
            />
            <Typography
              variant="h6"
              style={{
                color: "#214D73",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                fontSize: isMobile ? "18px" : "22px",
              }}
            >
              Support Stablecoin
            </Typography>
            <Typography
              style={{
                maxWidth: isMobile ? "100%" : "280px",
                margin: "0 auto",
                fontSize: isMobile ? "0.875rem" : "16px",
              }}
              variant="body2"
              color="textSecondary"
            >
              From stablecoins (USDC/USDT)
            </Typography>
          </Box>

          {/* Card 2 */}
          <Box
            style={{
              flex: isMobile ? "1 1 100%" : "1 1 30%",
              padding: "1rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              backgroundColor: "#E7E4E2",
              textAlign: "center",
              marginBottom: isMobile ? "1rem" : "0",
            }}
          >
            <img
              src={TokenizedImage}
              alt="Transparent Fees"
              style={{ width: "4rem", marginBottom: "1rem" }}
            />
            <Typography
              variant="h6"
              style={{
                color: "#214D73",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                fontSize: isMobile ? "18px" : "22px",
              }}
            >
              Transparent Fees
            </Typography>
            <Typography
              style={{
                maxWidth: isMobile ? "100%" : "300px",
                margin: "0 auto",
                fontSize: isMobile ? "0.875rem" : "16px",
              }}
              variant="body2"
              color="textSecondary"
            >
              Real-time quote engine and fee breakdown.
            </Typography>
          </Box>

          {/* Card 3 */}
          <Box
            style={{
              flex: isMobile ? "1 1 100%" : "1 1 30%",
              padding: "1rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              backgroundColor: "#E7E4E2",
              textAlign: "center",
            }}
          >
            <img
              src={CurrencyImage}
              alt="Major Fiat Currency Supported"
              style={{ width: "4rem", marginBottom: "1rem" }}
            />
            <Typography
              variant="h6"
              style={{
                color: "#214D73",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                fontSize: isMobile ? "18px" : "22px",
              }}
            >
              Major Fiat Currency Supported
            </Typography>
            <Typography
              style={{
                maxWidth: isMobile ? "100%" : "300px",
                margin: "0 auto",
                fontSize: isMobile ? "0.875rem" : "16px",
              }}
              variant="body2"
              color="textSecondary"
            >
              IDR, USD, GBP, EUR, SGD, KRW and more
            </Typography>
          </Box>

          {/* Repeat similar for remaining cards */}
          {/* Card 4 */}
          <Box
            style={{
              flex: isMobile ? "1 1 100%" : "1 1 30%",
              padding: "1rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              backgroundColor: "#E7E4E2",
              textAlign: "center",
            }}
          >
            <img
              src={OtcIcon1}
              alt="Direct Support"
              style={{ width: "4rem", marginBottom: "1rem" }}
            />
            <Typography
              variant="h6"
              style={{
                color: "#214D73",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                fontSize: isMobile ? "18px" : "22px",
              }}
            >
              Direct Support
            </Typography>
            <Typography
              style={{
                maxWidth: isMobile ? "100%" : "300px",
                margin: "0 auto",
                fontSize: isMobile ? "0.875rem" : "16px",
              }}
              variant="body2"
              color="textSecondary"
            >
              Personalized support via email, telegram, and WhatsApp.
            </Typography>
          </Box>

          <Box
            style={{
              flex: isMobile ? "1 1 100%" : "1 1 30%",
              padding: "1rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              backgroundColor: "#E7E4E2",
              textAlign: "center",
            }}
          >
            <img
              src={OtcIcon2}
              alt="Direct Support"
              style={{ width: "4rem", marginBottom: "1rem" }}
            />
            <Typography
              variant="h6"
              style={{
                color: "#214D73",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                fontSize: isMobile ? "18px" : "22px",
              }}
            >
              Transfer Globally
            </Typography>
            <Typography
              style={{
                maxWidth: isMobile ? "100%" : "300px",
                margin: "0 auto",
                fontSize: isMobile ? "0.875rem" : "16px",
              }}
              variant="body2"
              color="textSecondary"
            >
              SEPA, UK FPS and SWIFT{" "}
            </Typography>
          </Box>

          <Box
            style={{
              flex: isMobile ? "1 1 100%" : "1 1 30%",
              padding: "1rem",
              paddingTop: "2rem",
              paddingBottom: "2rem",
              backgroundColor: "#E7E4E2",
              textAlign: "center",
            }}
          >
            <img
              src={OtcIcon3}
              alt="Direct Support"
              style={{ width: "4rem", marginBottom: "1rem" }}
            />
            <Typography
              variant="h6"
              style={{
                color: "#214D73",
                fontWeight: "bold",
                marginBottom: "0.5rem",
                fontSize: isMobile ? "18px" : "22px",
              }}
            >
              Fast Remote Onboarding{" "}
            </Typography>
            <Typography
              style={{
                maxWidth: isMobile ? "100%" : "300px",
                margin: "0 auto",
                fontSize: isMobile ? "0.875rem" : "16px",
              }}
              variant="body2"
              color="textSecondary"
            >
              Average account opening time 48 hours{" "}
            </Typography>
          </Box>
          {/* Add other cards similarly */}
        </Box>
      </Container>
    </section>
  );
};

export default Solution;
